import React from 'react';

import { cn } from '@lyearn/style';
import { mergeOverrides, TypographyColors, TypographyVariants } from '@lyearn/ui';
import ProviderContent from '@/modules/corporate/modules/external-content/views/ExternalContentEditor/components/Provider/Provider';
import { ProviderType } from '@/types/schema';

export type ProviderOverrides = {
  root?: {
    className?: string;
  };
  Icon?: {
    className?: string;
    width?: number;
    height?: number;
  };
  Label?: {
    className?: string;
    variant?: TypographyVariants;
    color?: TypographyColors;
  };
};

const DEFAULT_OVERRIDES: ProviderOverrides = {
  root: {
    className: 'mt-auto',
  },
  Icon: {
    className: 'w-20 h-20',
    width: 20,
    height: 20,
  },
  Label: {
    className: 'ms-8',
    variant: 'body-short-02',
    color: 'text-text-primary',
  },
};

export const renderProviderLabel = (
  provider?: ProviderType | null,
  overrides?: ProviderOverrides,
) => {
  if (!provider) {
    return null;
  }

  const overridesClasses = mergeOverrides(DEFAULT_OVERRIDES, overrides);

  return (
    <ProviderContent
      className={cn('flex flex-row items-center', overridesClasses?.root?.className)}
      provider={provider}>
      <ProviderContent.Icon
        className={overridesClasses.Icon?.className}
        height={overridesClasses.Icon?.height}
        width={overridesClasses.Icon?.width}
      />
      <ProviderContent.Label
        className={overridesClasses.Label?.className}
        color={overridesClasses.Label?.color}
        variant={overridesClasses.Label?.variant}
      />
    </ProviderContent>
  );
};
